import React from 'react';

import { ErrorMessage, FormSpy } from '@atlassian/eoc-form';

import { type FieldErrorProps } from './types';

const FieldError: React.FC<FieldErrorProps> = ({ name }) => (
	<FormSpy
		subscription={{
			errors: true,
		}}
	>
		{({ errors }) =>
			errors?.[name] ? (
				<ErrorMessage {...({ fieldId: name } as any)}>{errors[name]}</ErrorMessage>
			) : null
		}
	</FormSpy>
);

export { FieldError };
